// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"3f0b007e","178":"c7438d44","419":"c7438d44","755":"c7438d44"}[chunkId] + ".chunk.css";
};